import { NON_INDEXABLE_LANDING_PATHS } from '../routes/publicLandingPaths';

const NOINDEX_ROUTE_PREFIXES = [
    '/dashboard',
    '/admin',
    '/login',
    '/signup',
    '/register',
    '/forgot',
    '/verify-email',
    '/reset-password',
    '/sso',
    '/ref',
    '/support/live',
    '/helpdesk/search',
    '/legal',
    '/billing',
    '/projects',
    '/landing-redesign-preview',
    '/release-control',
    '/landing-new',
    '/metadeck-preview',
    '/youtube-smm-preview',
    '/youtube-preview',
    '/pricing-sample',
] as const;

const matchesRoutePrefix = (pathname: string, prefix: string): boolean => (
    pathname === prefix || pathname.startsWith(`${prefix}/`)
);

export const isNoindexRoute = (pathname: string): boolean => {
    const normalizedPath = pathname !== '/' ? pathname.replace(/\/+$/, '') : pathname;
    const isLocalizedBlogIndex = /^\/[a-z]{2}\/blog$/.test(normalizedPath);
    return isLocalizedBlogIndex
        || NON_INDEXABLE_LANDING_PATHS.has(normalizedPath)
        || NOINDEX_ROUTE_PREFIXES.some((prefix) => matchesRoutePrefix(normalizedPath, prefix));
};

export const PRIVATE_ROBOTS_DIRECTIVES = 'noindex, nofollow, noarchive, nosnippet, noimageindex';

export const getNoindexPageTitle = (pathname: string): string => {
    if (matchesRoutePrefix(pathname, '/login')) return 'Log In | Traffic Creator';
    if (
        matchesRoutePrefix(pathname, '/signup')
        || matchesRoutePrefix(pathname, '/register')
        || matchesRoutePrefix(pathname, '/ref')
    ) return 'Create Account | Traffic Creator';
    if (matchesRoutePrefix(pathname, '/forgot')) return 'Reset Password | Traffic Creator';
    if (matchesRoutePrefix(pathname, '/verify-email')) return 'Verify Email | Traffic Creator';
    if (matchesRoutePrefix(pathname, '/reset-password')) return 'Choose a New Password | Traffic Creator';
    if (matchesRoutePrefix(pathname, '/support/live')) return 'Support Conversation | Traffic Creator';
    if (matchesRoutePrefix(pathname, '/admin')) return 'Admin | Traffic Creator';
    if (matchesRoutePrefix(pathname, '/dashboard')) return 'Dashboard | Traffic Creator';
    if (pathname.includes('preview') || matchesRoutePrefix(pathname, '/landing-new') || matchesRoutePrefix(pathname, '/pricing-sample')) {
        return 'Design Preview | Traffic Creator';
    }
    return 'Account | Traffic Creator';
};

export { NOINDEX_ROUTE_PREFIXES };
